import styled from 'styled-components'
import { FONT } from 'utils'

export const PermissionsHeader = styled.p`
   ${FONT({ size: '16px', weight: '500' })}
`
export const AllowedBlockTitle = styled.p`
   ${FONT({ size: '14px', weight: '400' })}
`
